var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"tip error",style:(_vm.getStyle())},_vm._l((_vm.ErrorList),function(e){return _c('span',{key:e},[_vm._v(_vm._s(e.Message)),_c('br')])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }